import {
    events as baseEvents,
} from '../component-base/props';
export const props = () => [
    {
        key: 'title',
        label: '标题',
        type: 'string',
    },
    {
        key: 'confirmText',
        label: '确认按钮文本',
        type: 'string',
    },
    {
        key: 'cancelText',
        label: '取消按钮文本',
        type: 'string',
    },
    {
        key: 'content',
        label: '内容（支持html）',
        type: 'html',
        props: {
            type: 'textarea', // TODO 以后考虑搞个富文本编辑器？
            rows: 5,
        },
    },
];

export const init = () => ({
    title: '',
    confirmText: '',
    cancelText: '',
    content: '',
});

export const name = '弹窗';

export const component = 'mobile-general-form-dialog';

export const events = [
    'confirm-dialog',
    'cancel-dialog',
    ...baseEvents,
];
